import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-12 md:py-20 px-5 md:px-6 bg-[#F2EFE9]" data-id="element-94">
      <div className="max-w-2xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-96">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center mb-8 md:mb-12 text-charcoal" data-id="element-97">
            If this is you…
          </h2>

          <div className="space-y-3 md:space-y-6" data-id="element-98">
            {['You walk into your house and your body tightens.', "The mess isn't the worst part. The noise is.", 'After-school turns into a crash.', 'Bedtime feels like a negotiation hostage situation.', 'You keep telling yourself, "Tomorrow I\'ll be calmer."'].map((item, index) => <div key={index} className="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-white/60 rounded-lg border border-charcoal/5" data-id="element-99">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-terracotta shrink-0 mt-0.5" data-id="element-100" />
                <p className="text-base md:text-lg text-charcoal leading-relaxed" data-id="element-101">
                  {item}
                </p>
              </div>)}
          </div>

          <div className="mt-8 md:mt-12 text-center" data-id="element-102">
            <p className="text-lg md:text-xl font-serif italic text-charcoal/80 mb-4 md:mb-6" data-id="element-103">
              And then tomorrow comes… and you're already at 80%.
            </p>
            <div className="inline-block px-5 md:px-8 py-3 md:py-4 bg-white border-2 border-muted-blue/20 rounded-lg shadow-sm" data-id="element-104">
              <p className="text-base sm:text-lg md:text-xl font-bold text-muted-blue" data-id="element-105">
                You don't need motivation. You need fewer decisions.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}